import InputMask from 'react-input-mask';

const InputControlMask = (props: any) => {
    return(
        <InputMask {...props} maskChar="" />
    );
}

export {InputControlMask}